// extracted by mini-css-extract-plugin
export var productImage = "_lk-1";
export var viewLink = "_lk-2";
export var wishlistItem = "_lk-0";